<template>
	<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row :gutter="20">
			<el-col>
				<el-card>
					<el-form ref="formSearch" :model="searchData" inline size="small" label-width="120px">
						<el-form-item prop="area">
							<el-select v-model="searchData.area" placeholder="省份">
								<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="level">
							<el-select v-model="searchData.level" placeholder="医院级别">
								<el-option v-for="item in levelOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="keywords">
							<el-input v-model="searchData.keywords" placeholder="医院名称" clearable maxlength="30">
							</el-input>
						</el-form-item>
						<el-form-item label="未填市场数据" prop="if_no_dataset">
							<el-switch v-model="searchData.if_no_dataset">
							</el-switch>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" plain @click="search()">搜索</el-button>
							<el-button type="info" plain @click="resetSearchForm('formSearch')">重置</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="primary" @click="addData()">新增医院</el-button>
							<el-button type="success" @click="exportData(searchData, '医院信息')">导出excel</el-button>
							<el-divider direction="vertical"></el-divider><strong></strong>
							<el-button type="warning" @click="showMigrationDialog()"
								v-if="$store.state.userPrivilege > 3">数据迁移</el-button>

						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>

		<el-row style="margin-top:15px;">
			<el-card>
				<el-table :data="tableData" style="width: 100%; " stripe>
					<el-table-column label="省份" prop="hospital_area" sortable />
					<el-table-column label="市/地区" prop="hospital_city" sortable />
					<el-table-column label="医院名称" prop="hospital_name" sortable width="280" />
					<el-table-column label="医院类型" prop="hospital_type" sortable></el-table-column>
					<el-table-column label="医院级别" prop="hospital_level" sortable></el-table-column>
					<el-table-column label="床位数" prop="hospital_bed_num" sortable></el-table-column>
					<el-table-column label="备注" prop="hospital_remark" sortable></el-table-column>
					<el-table-column label="数据记录" width="240">
						<template slot-scope="props">

							<el-tag size="small" effect="plain"><i
									class="el-icon-goods"></i>产品：{{ props.row.product_usage_record_num}}</el-tag>
							<span> </span>
							<el-tag size="small" effect="plain"><i
									class="el-icon-printer"></i>设备：{{ props.row.equip_record_num}}</el-tag>
							<span> </span>
							<el-tag size="small" effect="plain"><i
									class="el-icon-user"></i>人员：{{ props.row.expert_record_num}}</el-tag>
							<span> </span>
							<el-tag size="small" effect="plain"><i
									class="el-icon-truck"></i>供货：{{ props.row.supplyment_record_num}}</el-tag>
							<el-tag size="small" effect="plain"><i
									class="el-icon-receiving"></i>招标：{{ props.row.tender_record_num}}</el-tag>
							<el-tag size="small" type="success" effect="plain"><i
									class="el-icon-star-off"></i>服务：{{ props.row.visited_record_num}}</el-tag>


						</template>

					</el-table-column>
					<el-table-column label="更新人员" prop="hospital_user__person_name" sortable></el-table-column>
					<el-table-column label="更新时间" prop="update_date" sortable></el-table-column>
					<el-table-column label="历史记录" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="showHistory(scope.row.pk)">查看</el-button>
						</template>
					</el-table-column>
					<el-table-column width="150" label="操作" align="center">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" icon="el-icon-edit"
									@click="updateData(scope.$index, scope.row)">改</el-button>
								<el-button type="danger" size="mini" icon="el-icon-delete"
									@click="deleteData(scope.$index, scope.row)">删</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-row class="paginator hidden-sm-and-down">
					<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev, pager, next"
						:total="totalItems" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
						@current-change="handleCurrentChange" @size-change="handleSizeChange" />
				</el-row>

				<el-row class="paginator hidden-sm-and-up">
					<el-pagination background :current-page.sync="currentPage" layout="prev, pager, next"
						:total="totalItems" :page-size="pageSize" @current-change="handleCurrentChange"
						@size-change="handleSizeChange" prev-text="上一页" next-text="下一页" :pager-count="5" />
				</el-row>
			</el-card>
		</el-row>

		<!-- 条形图 -->
		<el-row>
			<el-col :span="24">
				<el-card style="margin-top: 10px;">
					<el-tabs v-model="barChartActiveName">
						<el-tab-pane label="市场数据填报统计" name="bar_completion">
							<div class="plate-card">
								<v-chart :options="bar_chart_completion" autoresize theme="light" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="产品入院统计" name="bar_share">
							<div class="plate-card">
								<v-chart :options="bar_chart_share" autoresize theme="light" />
							</div>
						</el-tab-pane>

					</el-tabs>
				</el-card>
			</el-col>
		</el-row>


		<!-- 新增数据表单 -->
		<el-dialog title="新增医院" :visible.sync="formAddDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :width="'60%'" :fullscreen="ifFullScreen">
			<el-form ref="formAddData" :rules="rules" :model="formAddData" :label-width="formLabelWidth" size="mini">
				<el-form-item label="医院名称" prop="hospital_name"><el-input
						v-model="formAddData.hospital_name" /></el-form-item>
				<el-form-item label="省份" prop="hospital_area">
					<el-select v-model="formAddData.hospital_area" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="市/地区" prop="hospital_city">
					<el-input v-model="formAddData.hospital_city" />
				</el-form-item>
				<el-form-item label="医院类型" prop="hospital_type">
					<el-select v-model="formAddData.hospital_type" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="医院等级" prop="hospital_level">
					<el-select v-model="formAddData.hospital_level" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in levelOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="床位数" prop="hospital_bed_num">
					<el-input-number v-model="formAddData.hospital_bed_num" :min="1" :max="99999"
						size="small"></el-input-number>
				</el-form-item>
				<el-form-item label="备注" prop="hospital_remark"><el-input type="textarea" autosize
						v-model="formAddData.hospital_remark" /></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formAddData')">取 消</el-button>
				<el-button type="danger" @click="submitAddForm('formAddData')">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 更新数据表单 -->
		<el-dialog title="修改客户信息" :visible.sync="formUpdateDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :fullscreen="ifFullScreen">
			<el-form ref="formUpdateData" :rules="rules" :model="formUpdateData" :label-width="formLabelWidth"
				size="mini">
				<el-form-item label="医院名称" prop="hospital_name"><el-input
						v-model="formUpdateData.hospital_name" /></el-form-item>
				<el-form-item label="省份" prop="hospital_area">
					<el-select v-model="formUpdateData.hospital_area" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="市/地区" prop="hospital_city">
					<el-input v-model="formUpdateData.hospital_city" />
				</el-form-item>
				<el-form-item label="医院等级" prop="hospital_level">
					<el-select v-model="formUpdateData.hospital_level" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in levelOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="医院类型" prop="hospital_type">
					<el-select v-model="formUpdateData.hospital_type" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="床位数" prop="hospital_bed_num">
					<el-input-number v-model="formUpdateData.hospital_bed_num" :min="1" :max="99999"
						size="small"></el-input-number>
				</el-form-item>
				<el-form-item label="备注" prop="hospital_remark"><el-input type="textarea" autosize
						v-model="formUpdateData.hospital_remark" /></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formUpdateDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitUpdateForm('formUpdateData')">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 历史记录弹窗 -->
		<el-dialog title="历史记录" :visible.sync="dialogHistoryVisible" :width="'80%'" :fullscreen="ifFullScreen">
			<el-table :data="tableHistoryData">
				<el-table-column label="操作时间" prop="history_date" />
				<el-table-column label="操作" prop="history_type" />
				<!-- <el-table-column label="操作人" prop="history_user" /> -->
				<el-table-column label="数据">
					<el-table-column label="省份" prop="hospital_area" />
					<el-table-column label="市/地区" prop="hospital_city" show-overflow-tooltip />
					<el-table-column label="医院名称" prop="hospital_name" show-overflow-tooltip />
					<el-table-column label="医院类型" prop="hospital_type" />
					<el-table-column label="医院级别" prop="hospital_level" />
					<el-table-column label="床位数" prop="hospital_bed_num" />
					<el-table-column label="备注" prop="hospital_remark" show-overflow-tooltip />
					<el-table-column label="填报人" prop="hospital_user" />
				</el-table-column>
			</el-table>
		</el-dialog>

		<!-- 数据迁移弹窗 -->
		<el-dialog title="医院数据迁移" :visible.sync="migrationDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<el-form :model="formMigrationData" :rules="rules" ref="formMigrationData" label-width="100px">
				<el-form-item label="从该医院" prop="from_hospital"
					:rules="{ required: true, message: '请填写待迁移医院', trigger: 'blur' }">
					<el-select v-model="formMigrationData.from_hospital" placeholder="请选择待迁移医院"
						:remote-method="remoteListHospital" filterable remote reserve-keyword
						:loading="migration_loading">
						<el-option v-for="item in hospitalOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="迁移至医院" prop="to_hospital"
					:rules="{ required: true, message: '请填写迁移目标医院', trigger: 'blur' }">
					<el-select v-model="formMigrationData.to_hospital" placeholder="请选择迁移至医院"
						:remote-method="remoteListHospital" filterable remote reserve-keyword
						:loading="migration_loading">
						<el-option v-for="item in hospitalOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="migrationDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="migrateData('formMigrationData')">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				searchData: {
					keywords: '',
					area: '',
					level: '',
					if_no_dataset: false,
				},
				formAddDialogVisible: false,
				formUpdateDialogVisible: false,
				ifFullScreen: false,
				dialogHistoryVisible: false,
				migrationDialogVisible: false,
				formAddData: {
					pk: '',
					hospital_name: '',
					hospital_area: '',
					hospital_level: '',
					hospital_type: '',
					hospital_remark: '',
					hosptial_city: '',
					hospital_bed_num: ''
				},
				hospitalOptions: [],
				formUpdateData: {
					pk: '',
					hospital_name: '',
					hospital_area: '',
					hospital_level: '',
					hospital_type: '',
					hospital_remark: '',
					hosptial_city: '',
					hospital_bed_num: ''
				},
				formMigrationData: {
					from_hospital: '',
					to_hospital: ''
				},
				bar_chart_completion: {},
				bar_chart_share: {},
				// 	brand_name: ''
				// },
				//新增和更新表单的验证规则
				rules: {
					hospital_name: [{
						required: true,
						message: '请填写医院名称',
						trigger: 'blur'
					}, {
						max: 40,
						message: '长度不超过40个字符',
						trigger: 'blur'
					}],
					hospital_area: [{
						required: true,
						message: '请选择或填写省份',
						trigger: 'change'
					}],
					hospital_city: [{
						required: true,
						message: '请填写地区',
						trigger: 'change'
					}],
					hospital_level: [{
						required: true,
						message: '请选择医院级别',
						trigger: 'change'
					}],
					hospital_type: [{
						required: true,
						message: '请选择医院类型',
						trigger: 'change'
					}]
				},
				formLabelWidth: '100px',
				barChartActiveName: 'bar_completion',
				totalItems: 100,
				currentPage: 1,
				pageSize: 20,
				deleteItemPk: '',
				loading: false,
				migration_loading: false,
				// brandOptions: [],
				tableHistoryData: [],
				visible: false,
				provinceOptions: [{
						value: '北京',
						label: '北京'
					},
					{
						value: '天津',
						label: '天津'
					},
					{
						value: '上海',
						label: '上海'
					},
					{
						value: '重庆',
						label: '重庆'
					},
					{
						value: '河北',
						label: '河北'
					},
					{
						value: '山西',
						label: '山西'
					},
					{
						value: '辽宁',
						label: '辽宁'
					},
					{
						value: '吉林',
						label: '吉林'
					},
					{
						value: '黑龙江',
						label: '黑龙江'
					},
					{
						value: '江苏',
						label: '江苏'
					},
					{
						value: '浙江',
						label: '浙江'
					},
					{
						value: '安徽',
						label: '安徽'
					},
					{
						value: '福建',
						label: '福建'
					},
					{
						value: '江西',
						label: '江西'
					},
					{
						value: '山东',
						label: '山东'
					},
					{
						value: '河南',
						label: '河南'
					},
					{
						value: '湖北',
						label: '湖北'
					},
					{
						value: '湖南',
						label: '湖南'
					},
					{
						value: '广东',
						label: '广东'
					},
					{
						value: '甘肃',
						label: '甘肃'
					},
					{
						value: '四川',
						label: '四川'
					},
					{
						value: '贵州',
						label: '贵州'
					},
					{
						value: '海南',
						label: '海南'
					},
					{
						value: '云南',
						label: '云南'
					},
					{
						value: '青海',
						label: '青海'
					},
					{
						value: '陕西',
						label: '陕西'
					},
					{
						value: '广西',
						label: '广西'
					},
					{
						value: '西藏',
						label: '西藏'
					},
					{
						value: '宁夏',
						label: '宁夏'
					},
					{
						value: '新疆',
						label: '新疆'
					},
					{
						value: '内蒙',
						label: '内蒙'
					},
					{
						value: '澳门',
						label: '澳门'
					},
					{
						value: '香港',
						label: '香港'
					},
					{
						value: '台湾',
						label: '台湾'
					}
				],
				levelOptions: [{
						value: '三级特等',
						label: '三级特等'
					},
					{
						value: '三级甲等',
						label: '三级甲等'
					},
					{
						value: '三级乙等',
						label: '三级乙等'
					},
					{
						value: '三级丙等',
						label: '三级丙等'
					},
					{
						value: '二级甲等',
						label: '二级甲等'
					},
					{
						value: '二级乙等',
						label: '二级乙等'
					},
					{
						value: '二级丙等',
						label: '二级丙等'
					},
					{
						value: '一级甲等',
						label: '一级甲等'
					},
					{
						value: '一级乙等',
						label: '一级乙等'
					},
					{
						value: '一级丙等',
						label: '一级丙等'
					}
				],
				typeOptions: [{
						value: '综合',
						label: '综合'
					},
					{
						value: '专科',
						label: '专科'
					},
					{
						value: '教学',
						label: '教学'
					},
					{
						value: '诊所',
						label: '诊所'
					}
				],
				//标准条形图设置
				bar_chart_data: {
					title: {
						text: '市场数据填报统计',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							// 初始化 tooltip 文本
							let tooltipText = `${params[0].axisValue}<br/>`;

							// 计算当前分类轴的总值（用于百分比计算）
							let totalValue = params.reduce((acc, item) => acc + item.value, 0);

							// 遍历所有系列的数据项，构建每一行的文本
							params.forEach((item) => {
								// 格式化当前数据项的值
								const formattedValue = item.value.toLocaleString();

								// 计算百分比
								const percentage = totalValue !== 0 ? ((item.value / totalValue) * 100)
									.toFixed(2) : '0.00';

								// 构建 tooltip 的每一行
								tooltipText +=
									`${item.marker}${item.seriesName}：${formattedValue}（家）（${percentage}%）<br/>`;
							});
							tooltipText +=
								`合计：${totalValue.toLocaleString()}(家)`;

							return tooltipText;
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 5,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '5%',
						right: '5%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							interval: 0,
							fontSize: '0.8rem',
							// rotate:38
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '有记录',
							type: 'bar',
							stack: 'catalog',
							emphasis: {
								focus: 'series'
							},
							data: []
						},
						{
							name: '无记录',
							type: 'bar',
							stack: 'catalog',
							emphasis: {
								focus: 'series'
							},
							data: []
						},

					]
				},
			};
		},
		methods: {
			//通用函数-获取数据
			getData(queryData, currentPage, pageSize) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				fd.append('currentpage', currentPage);
				fd.append('pagesize', pageSize);

				this.$axios({
						url: '/apim/get/hospital/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.tableData = response.data.data;
							that.totalItems = response.data.totalItemNum;
							that.bar_chart_completion.xAxis[0].data = response.data.bar_chart_completion_xAxis_data;
							that.bar_chart_completion.series = response.data.bar_chart_completion_series_data;
							that.bar_chart_share.xAxis[0].data = response.data.bar_chart_share_xAxis_data;
							that.bar_chart_share.series = response.data.bar_chart_share_series_data;
							that.loading = false;
						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},
			//通用功能 - 关键字搜索
			search() {
				let that = this;
				this.currentPage = 1;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//重置搜索表单
			resetSearchForm(formName) {
				let that = this;
				this.$refs[formName].resetFields();
				this.$refs[formName].clearValidate();
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//新增数据-对话框
			addData() {
				this.formAddDialogVisible = true;
			},
			//新增数据-提交
			submitAddForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formAddData;
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						// console.log(this.formAddData);
						this.$axios({
								url: '/apim/add/hospital/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == 200) {
									that.reload();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//新增数据 - 重置表单
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.$refs[formName].clearValidate();
				this.formAddDialogVisible = false;
			},
			//更新数据 - 对话框
			updateData(index, row) {
				//解除双向绑定
				this.formUpdateData = JSON.parse(JSON.stringify(row));
				this.formUpdateDialogVisible = true;
			},
			//更新数据-提交
			submitUpdateForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formUpdateData;
						//遍历添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						this.$axios({
								url: '/apim/update/hospital/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == 200) {
									that.getData(that.searchData, that.currentPage, that.pageSize);
									that.formUpdateDialogVisible = false;
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//删除数据 - 对话框
			deleteData(index, row) {
				let deleteItemPk = JSON.parse(JSON.stringify(row)).pk;
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.submitDeleteData(deleteItemPk);
					})
					.catch(() => {});
			},
			//删除数据-提交
			submitDeleteData(dataPk) {
				let that = this;
				let fd = new FormData();
				fd.append('pk', dataPk);
				this.$axios({
						url: '/apim/delete/hospital/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						// console.log(res.data);
						if (res.data.code == 200) {
							that.getData();
						} else {
							that.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 查看修改历史记录
			showHistory(id) {
				let that = this;
				this.dialogHistoryVisible = true;
				this.$axios.get('/apim/history/hospital/', {
					params: {
						id: id,
					}
				}).then(response => {
					if (response.data.history_data) {
						this.tableHistoryData = response.data.history_data;
					} else {
						that.$message({
							message: response.data.errors,
							type: 'warning',
						});
					}
				}).finally(() => {

				});
			},
			//分页跳转
			handleCurrentChange(val) {
				let that = this;
				this.currentPage = val;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//每页显示条数更改
			handleSizeChange(val) {
				let that = this;
				this.pageSize = val;
				this.currentPage = 1;
				this.getData(that.searchData, that.currentPage, that.pageSize);
			},
			//路由跳转
			jumpTo(name, id) {
				var fullpath = name + id + '/';
				this.$router.push({
					path: fullpath
				});
			},
			//导出医院数据
			exportData(queryData, filename) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				let fileName = filename + Date.now();
				this.$axios({
						url: '/apim/export/hospital/',
						responseType: 'blob',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});
			},
			//显示数据迁移对话框
			showMigrationDialog() {
				this.migrationDialogVisible = true,
					this.formMigrationData.from_hospital = '',
					this.formMigrationData.to_hospital = '',
					this.hospitalOptions = []
			},
			//远程获取医院清单
			remoteListHospital(query) {
				if (query !== '') {
					let that = this;
					this.migration_loading = true;
					setTimeout(() => {
						this.$axios
							.get('/apim/list/hospital/', {
								params: {
									keywords: query
								}
							})
							.then(function(response) {
								that.hospitalOptions = response.data;
							})
							.catch(function(error) {
								console.log(error);
							});
						this.migration_loading = false;
					}, 200);
				} else {
					this.hospitalOptions = [];
				}

			},

			// 数据迁移提交
			migrateData(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.$confirm('将进行数据迁移操作, 是否继续?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							})
							.then(() => {
								this.loading = true;
								let that = this;
								let fd = new FormData();
								let formData = this.formMigrationData;
								//遍历添加表单数据
								for (let key in formData) {
									fd.append(key, formData[key]);
								}
								this.$axios({
										url: '/apim/migrate/hospital/',
										method: 'post',
										data: fd,
										headers: {
											'Content-Type': 'multipart/form-data'
										}
									})
									.then(function(res) {
										if (res.data.code == '200') {
											that.$message({
												message: res.data.message,
												type: 'success'
											});
											that.getData(that.searchData, that.currentPage, that.pageSize);
											that.migrationDialogVisible = false;
										} else {
											that.$message({
												message: res.data.message,
												type: 'warning'
											});
										}
										that.loading = false;
									})
									.catch(function(error) {
										console.log(error);
										that.loading = false;
									});
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
		},
		mounted() {
			let that = this;
			this.getData(that.searchData, that.currentPage, that.pageSize);
			that.ifFullScreen = document.body.clientWidth > 720 ? false : true;
		},
		created() {
			// 深拷贝数据以取消双向绑定

			this.bar_chart_completion = {
				...JSON.parse(JSON.stringify(this.bar_chart_data)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_data.tooltip,
					formatter: this.bar_chart_data.tooltip.formatter
				}
			};
			this.bar_chart_share = {
				...JSON.parse(JSON.stringify(this.bar_chart_data)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_data.tooltip,
					formatter: this.bar_chart_data.tooltip.formatter
				}
			};


		},
	};
</script>

<style scoped>
	.plate-card {
		width: 100%;
		height: 420px;
		padding: 10px;
		box-sizing: border-box;
	}

	.echarts {
		width: 100%;
		height: 100%;
	}
</style>